<template>
  <div class="bg-color">
    <div class="wrapper clearFix">
      <!--Left模块-->
      <div class="left">
        <dl class="lt-menu">
          <dt>混改服务</dt>
          <dd class="on">
            <router-link to='/author'>新闻资讯</router-link>
          </dd>
          <dd>
            <router-link to='/policy'>政策法规</router-link>
          </dd>
          <dd>
            <router-link to='/case'>案例分析</router-link>
          </dd>
          <dd>
            <router-link to='/partake'>如何参与</router-link>
          </dd>
          <dd>
            <router-link to='/problem'>常见问题</router-link>
          </dd>
        </dl>

      </div>
      <!--End:Left模块-->
      <!--Right模块-->
      <div class="right" id="right_div">
        <ul class="notice-list" v-for="info in newsList" >
          <li>
            <div class="txt">
              <div class="title"><a><router-link :to="{path:'/serviceDetail',query: {id: info.id,catid: 12}}">· {{info.title}}</router-link></a></div>
            </div>
            <div class="date">
              <span class="year">{{info.updatetime|dateFormat}}</span>
            </div>
          </li>
        </ul>
        <div style="text-align: center;margin-top:50px;display: none;" id="noService">
          <img src="../assets/no-data.png">
        </div>
        <div id="promptInfo" style="text-align: center;color:#666;margin-top:20px;"></div>
      </div>
      <!--End:Right模块-->
    </div>
  </div>
</template>

<style scoped>
  @import "../style/service.css";
</style>

<script>
import { mapState } from 'vuex';
import global from '../components/public/Common.vue';
export default {
  name: 'author',
  data() {
    return {
      serviceUrl:global.serviceUrl,
      token:global.token,
      orgid:global.orgid,

      newsList: [],
    }
  },
  created: function () {
      //首次进入页面，获取第一页数据
    let _this = this;
    loadData(_this,1,this.serviceUrl,this.token,this.orgid);
  },
  mounted: function () {
    //在线客服
    // const oScript = document.createElement('script');
    // oScript.type = 'text/javascript';
    // oScript.src = 'https://qiyukf.com/script/114476681b34a2798e2b4dabdd9b9235.js';
    // document.body.appendChild(oScript);
  },
  filters: {
    dateFormat:function(time) {
      return global.dateFormatYmd(time)
    },
  },
}

function loadData(tar,pageIndex,url,token,orgid) {
  $.ajax({
    url: url,
    type: 'post',
    dataType: 'jsonp',
    data: {
      'token':token,
      'catid':12,
      'orgid':orgid,
      'pageIndex':pageIndex,
      'pageSize':10
    },
    success: function (data) {
      if (data.msg == 200) {
        if (data.result.totalData == 0) {//数据为空
          $("#noService").css("display", "block");
          return;
        }
        tar.newsList = data.result.data;
      } else {
        if (data.result.totalData == 0) {//数据为空
          $("#noService").css("display", "block");
          return;
        }
        alert(data.msg);
      }
    },
    error: function (data) {

    }
  });
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/Author.vue